
import { useState } from "react";
import { AimOutlined, PushpinFilled, ShopFilled } from "@ant-design/icons";

export const CenterMarker = ({ lat, lng }: any) => {
        
    const [panelVisible, setPanelVisible] = useState(false);
    
    const handleMouseEnter = () => {
        setPanelVisible(true);                
    };
    
    const handleMouseLeave = () => {
        setPanelVisible(false);                
    };

    const onClick = () => {
        
    }

    return (
        <>
            <div style={{position: 'absolute', transform: 'translate(-50%, -50%)'}} onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave} onClick={onClick}>
                <AimOutlined style={{fontSize: '34px', color:'black'}}/>
            </div>
        </>
    )
}
